import type { StatelessFunctionalComponent } from 'react'
import React, { Fragment, useEffect } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import { useDispatch } from 'react-redux'
import { getUrlParams } from 'shared/store/kingdom/profile'
import { getUrlParams as urlParams } from 'shared/utils/ecommerce/utils'

type Props = {
    component: StatelessFunctionalComponent<any>,
    exact?: boolean,
    isAllowed?: string,
    loading?: boolean,
    location?: Object,
    path?: string,
    intl: IntlShape
}

const ProtectedRoute = (props: Props) => {
    const dispatch = useDispatch()
    const { isAllowed, location, intl, loading, ...routeProps } = props
    const information = intl.formatMessage({
        id: 'routes.kingdom.information.full'
    })
    useEffect(() => {
        if (location && location.pathname === information && location.search) {
            const params = urlParams(location.search)
            dispatch(getUrlParams(params))
        }
    }, [])
    return (
        <Fragment>
            {!isAllowed && !loading ? (
                <Redirect
                    to={{
                        pathname: intl.formatMessage({
                            id: 'routes.signin'
                        }),
                        state: { from: location }
                    }}
                />
            ) : (
                <Route {...routeProps} />
            )}
        </Fragment>
    )
}

const ProtectedRouteComponent = injectIntl(ProtectedRoute)

export { ProtectedRouteComponent }
